module.exports = {
    WEB_SERVER : 'https://beta.pdgcms.com',
    ENTRY: '',
    DISPLAY: 1,
    AUTHKEY: 'jzg2rmttjrqrl8o0xtiqvl',
    ENV: 'dev',
    SCREEN_CONFIG:{
        ORIENTATION: 'horizontal',
        DISPLAYS_WIDTH: 1,
        DISPLAYS_HEIGHT: 1,
        RATIO: '16x9'
    },
    sockets: {
	enabled: true
    }
}



//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 34
// module chunks = 0